export default {
  account: {
    academy_capitalized: "学院",
    change_photo: "更换照片",
    currency: "货币",
    currency_description: "用于学生学费和教师薪资的货币。",
    email_capitalized: "电子邮件",
    first_name_capitalized: "名",
    language: "语言",
    language_settings: "语言设置",
    last_name_capitalized: "姓",
    personal_information: "个人信息",
    plan_usage: "订阅计划 & 使用情况",
    policy: "政策",
    policy_setting_before: "小时前",
    policy_setting_cancel: "取消",
    policy_setting_cancel_subtitle: "设置提前多少小时可以提交课程取消请求",
    policy_subtitle: "设置提前多少小时可以提交课程改期请求",
    profile: "个人资料",
    reschedule: "改期",
    subscription: "订阅",
    subscription_info_contact: "{'请联系 yan@getfunclass.com 以管理或取消您的订阅。谢谢！'}",
    subtitle: "您可以在此管理您的账户设置。",
    title: "账户设置"
  },
  auth: {
    agency_name: "培训机构",
    agree_to: "我同意",
    alreadyhasaccount: "已经有账户？",
    confirmPassword: "确认密码",
    createaccount: "创建账户",
    email: "电子邮件",
    email_enter: "输入您的电子邮件",
    email_send: "发送电子邮件",
    firstname: "名字",
    firstname_student: "学生名字",
    forgotpassword: "忘记密码？",
    hasaccount: "没有账户？",
    lastname: "姓氏",
    login: "登录",
    loginbutton: "登录",
    logout: "登出",
    no_active_account: "未找到与提供的凭据匹配的有效账户",
    password: "密码",
    passwordreset: "重置您的密码",
    passwordresetbutton: "重置密码",
    required: {
      agency_name: "机构名称为必填项",
      email: "电子邮件为必填项",
      email_exists: "该电子邮件账户已存在",
      first_name: "名字为必填项",
      invalid_email: "电子邮件无效",
      last_name: "姓氏为必填项",
      password: "密码为必填项",
      password_length: "密码长度必须至少为 8 个字符",
      password_requirement: "密码必须包含至少一个大写和一个小写字母、一个数字和一个特殊字符（@ $ ! % * ? & #）"
    },
    reset: "重置",
    signup: "注册",
    signup_subtitle: "输入您的信息以在 Funclass 创建账户",
    terms: "条款须知"
  },
  button: {
    archive: "归档",
    copy: "复制！",
    delete: "删除",
    edit: "编辑",
    invite: "邀请",
    save: "保存",
    submit: "提交",
    unarchive: "取消归档"
  },
  course: {
    chinese_students: "该课程有来自中国大陆的学生",
    class_name: "课程名称",
    class_name_placeholder: "在此输入您的课程名称",
    class_settings: {
      account_type: "账户类型",
      account_type_warning_non_gamified: "学生不会拥有宠物，也不会获得任何 XP/HP。",
      account_type_warning_setup: "游戏化类型只能在课程创建时设置一次。",
      enable_breakout_room: "启用分组讨论室",
      gamified: "游戏化",
      non_gamified: "非游戏化",
      recording_exclude_webcam: "录制内容不包含学生的摄像头画面",
      title: "课堂设置"
    },
    create: "添加课程",
    delete: "删除",
    delete_confirmation: "删除确认",
    delete_message: "您确定要删除此课程吗？",
    delete_student: "您确定要将此学生从课程中移除吗？",
    duration: "时长",
    duration_time_unit: "分钟",
    edit: "编辑课程",
    filters: {
      active: "活跃课程",
      all: "所有课程",
      archived: "已归档课程"
    },
    join: "加入课堂",
    link_valid_for: "此链接有效期为 {n} 天。",
    name_too_short: "课程名称必须至少包含 2 个字符",
    no_content: {
      filtered: {
        subtitle: "请尝试更改筛选条件。",
        title: "暂无课程"
      },
      general: {
        teacher_subtitle: "点击“添加课程”按钮开始！",
        teacher_subtitle_agency: "尚未分配课程，请等待您的学院为您分配课程。",
        title: "尚未创建课程"
      }
    },
    notify: {
      archive_course_error: "归档课程时出错",
      archive_course_success: "{courseName} 课程已成功归档！",
      copy_link_error: "复制链接时出错",
      copy_link_success: "已复制！",
      delete_course_error: "删除课程时出错",
      edit_course_error: "编辑课程时出错",
      required_fields: "请填写必填项",
      start_meeting_error: "启动会议时出错，请重试。",
      unarchive_course_error: "取消归档课程时出错",
      unarchive_course_success: "{courseName} 课程已成功取消归档！"
    },
    please_resubscribe: "请重新订阅 Funclass 以继续使用。",
    progress: "学习进度",
    resubscribe: "重新订阅",
    share: "分享课程",
    shareText: "分享链接邀请您的学生加入课程！",
    start: "开始上课",
    subscription_expired: "订阅已过期",
    title: "课程控制面板",
    view: "查看课程"
  },
  datetime: {
    days: {
      friday: "星期五",
      initials: {
        friday: "五",
        monday: "一",
        saturday: "六",
        sunday: "日",
        thursday: "四",
        tuesday: "二",
        wednesday: "三"
      },
      monday: "周一",
      saturday: "周六",
      short: {
        friday: "周五",
        monday: "周一",
        saturday: "周六",
        sunday: "周日",
        thursday: "周四",
        tuesday: "周二",
        wednesday: "周三"
      },
      sunday: "周日",
      thursday: "周四",
      tuesday: "周二",
      wednesday: "周三"
    },
    time_format: "于 {time}",
    today: "今天",
    tomorrow: "明天",
    yesterday: "昨天"
  },
  homework: {
    assign: {
      assignment_info: {
        attach_files: "附件",
        attachments: "附件列表",
        choose_class: "选择要分配的课程",
        class: "课程",
        description: "作业描述",
        due_date: "截止日期（您的本地时间）",
        due_date_past: "截止日期必须是未来的时间",
        submission_required: "需要提交",
        title: "标题",
        title_required: "标题为必填项"
      },
      confirm_leave: "您确定要离开此页面吗？您的更改将不会被保存。",
      create: "分配",
      remove_attachment: "移除",
      title: "分配作业",
      upload_attachments: "上传您的附件"
    },
    dashboard: {
      archived: "已归档",
      create: "分配作业",
      delete_button: "删除 {assignment}",
      delete_confirmation: "删除确认",
      delete_message: "您确定要删除此作业吗？",
      due: "截止日期",
      filters: {
        all_classes: "所有课程",
        all_graded: "所有已评分作业",
        any_status: "任何状态",
        archived: "已归档",
        assigned: "已分配",
        no_submission_needed: "无需提交",
        to_be_graded: "待评分"
      },
      graded_on: "评分时间",
      header: {
        class: "课程",
        due: "截止日期",
        status: "状态",
        title: "标题"
      },
      na: "N/A",
      no_content: {
        completed: {
          subtitle: "您的已完成作业将在此显示，等待评分。",
          title: "没有已完成的作业"
        },
        filtered: {
          subtitle: "请尝试更改筛选条件以查找您要的作业。",
          title: "没有符合筛选条件的作业"
        },
        general: {
          subtitle: "点击“分配作业”按钮开始！",
          title: "尚未创建作业"
        },
        graded: {
          subtitle: "您的已评分作业将在此显示。",
          title: "没有已评分的作业"
        },
        pending: {
          subtitle: "请稍后查看新的作业。",
          title: "没有待处理的作业"
        }
      },
      no_due_date: "无截止日期",
      notify: {
        archive_assignment_error: "归档作业失败，请稍后再试。",
        archive_assignment_success: "作业已成功归档！",
        delete_assignment_error: "删除作业失败，请稍后再试。",
        delete_assignment_success: "作业已成功删除！",
        unarchive_assignment_error: "取消归档作业失败，请稍后再试。",
        unarchive_assignment_success: "作业已成功取消归档！"
      },
      num_submitted: "{submitted} / {total} 已提交",
      submission_not_required: "无需提交",
      submit: "提交",
      submitted_on: "提交时间",
      tabs: {
        completed: "已完成",
        graded: "已评分",
        pending: "待处理"
      },
      title: "我的作业",
      view_submission: "查看"
    },
    details: {
      attach_files: "附件",
      attachments: "附件列表",
      delete_button: "删除 {assignment}",
      delete_confirmation: "删除确认",
      delete_message: "您确定要删除此作业吗？",
      description: "描述",
      download_attachment: "下载",
      due: "截止日期",
      edit_homework: "编辑作业",
      edit_submission: "编辑提交内容",
      graded_on: "评分时间",
      homework_details: "作业详情",
      homework_submission: "作业提交",
      not_submitted: "未提交",
      post_submission_success: "提交成功！",
      remove_attachment: "移除",
      reward: "奖励：",
      student_submissions: "学生提交情况",
      submission_not_required: "无需提交",
      submit_homework: "提交",
      submitted_on: "提交时间",
      teacher_feedback: "教师反馈",
      title: "作业",
      upload_attachments: "上传您的附件",
      view_submission: "查看",
      your_submission: "您的提交内容"
    },
    edit: {
      assignment_info: {
        attach_files: "附件",
        attachments: "附件列表",
        choose_class: "选择要分配的课程",
        class: "课程",
        description: "作业描述",
        due_date: "截止日期（您的本地时间）",
        due_date_past: "截止日期必须是未来的时间",
        submission_required: "需要提交",
        title: "标题",
        title_required: "标题为必填项"
      },
      confirm_leave: "您确定要离开此页面吗？您的更改将不会被保存。",
      keep_attachment: "保留",
      remove_attachment: "移除",
      save_changes: "保存更改",
      title: "编辑作业",
      upload_attachments: "上传您的附件"
    },
    edit_submission: {
      attach_files: "附件",
      attachments: "附件列表",
      description: "描述",
      download_attachment: "下载",
      due: "截止日期",
      edit_submission_success: "提交内容编辑成功！",
      homework_details: "作业详情",
      keep_attachment: "保留",
      last_submitted_on: "上次提交时间",
      remove_attachment: "移除",
      resubmit_homework: "重新提交",
      title: "编辑提交内容",
      upload_attachments: "上传您的附件",
      your_submission: "您的提交内容"
    },
    submission_details: {
      attach_files: "附件",
      attachments: "附件列表",
      description: "作业提交",
      download_attachment: "下载",
      graded_on: "评分时间",
      remove_attachment: "移除",
      reward: "奖励：",
      reward_xp: "奖励 XP",
      reward_xp_placeholder: "输入 XP 数量",
      rewarding: "奖励中",
      save_reward: "保存",
      save_reward_success: "奖励金额保存成功！",
      send_feedback: "发送",
      send_feedback_success: "反馈发送成功！",
      submitted_on: "提交时间",
      teacher_feedback: "教师反馈",
      title: "作业",
      your_feedback: "您的反馈"
    }
  },
  inclass: {
    endLesson: "您想要结束课程吗？"
  },
  inclassQuiz: {
    dragMe: "拖动我",
    folderTitle: "选择文件夹",
    modeTitle: "选择模式",
    noQuizYet1: "暂无测验。",
    noQuizYet2: "请先在课程外创建测验。",
    quizRuleDescription1: "• 每答对一道题，怪物失去一条生命",
    quizRuleDescription2: "• 每答错一道题，学生失去一条生命",
    quizRuleDescription3: "• 在测验结束时，学生必须比怪物拥有更多生命才能获胜！",
    quizRuleDescriptionStudent1: "• 每答对一道题，怪物失去一条生命",
    quizRuleDescriptionStudent2: "• 每答错一道题，您失去一条生命",
    quizRuleDescriptionStudent3: "• 在测验结束时，您必须比怪物拥有更多生命才能获胜！",
    studentsJoinedCount: "学生已加入",
    teacherPreStartQuiz: "您即将开始测验...",
    title: "选择测验"
  },
  lesson_status: {
    cancelled: "已取消",
    completed: "已完成",
    completed_absence: "已完成（缺席）",
    no_show: "未出席",
    ongoing: "进行中",
    rescheduled: "已改期",
    scheduled: "已安排",
    started: "已开始"
  },
  meeting: {
    attention_tracker_disable: "禁用注意力追踪器",
    attention_tracker_enable: "启用注意力追踪器",
    button_join_quiz: "加入进行中的测验"
  },
  misc: {
    handbook: "手册"
  },
  my_calendar: {
    abort: "取消",
    accept_request: "接受请求",
    all_members: "所有成员",
    attendees: "参与者",
    cancel: "取消",
    cancel_lesson: "取消课程",
    cancel_lesson_title: "取消课程",
    cancellation_constraint: "所有取消必须至少提前 {hours} 小时进行",
    confirm: "确认",
    confirm_approve_reschedule: "您确定要批准此更改时间的请求吗？",
    course: "课程",
    date: "日期",
    date_time: "日期和时间",
    day: "天",
    from: "从",
    from_admin: "管理员发起",
    join: "加入",
    month: "月",
    next: "下一个",
    notes: "备注",
    notify: {
      approve_reschedule_request_error: "未能批准重新安排请求。请重试。",
      approve_reschedule_request_success: "重新安排请求已成功批准。",
      request_cancel_error: "未能提交课程取消请求。请重试。",
      request_cancel_success: "课程取消请求已成功提交。",
      request_reschedule_error: "未能请求课程重新安排。请重试。",
      request_reschedule_success: "课程重新安排请求已成功提交。"
    },
    previous: "上一个",
    reschedule: "更改时间",
    reschedule_constraint: "更改时间的请求必须至少提前 {hours} 小时发起",
    reschedule_lesson_title: "更改课程时间",
    reschedule_note: "更改备注",
    reschedule_requests: "更改时间请求",
    save: "保存",
    send_request: "发送请求",
    students: "学生",
    subtitle: "您可以在这里查看和管理所有课程和可用时间。",
    suggest_alternative_title: "建议其他时间",
    teachers: "老师",
    title: "我的日历",
    to: "到",
    today: "今天",
    view_lesson: "查看课程",
    week: "周",
    your_requests: "您的请求"
  },
  my_items: {
    change_pet_button: "更换宠物",
    confirm_button: "确认",
    feed_button: "喂食",
    go_to_shop_button: "前往商店",
    no_content: {
      accessories: {
        subtitle: "你还没有购买任何物品。",
        title: "暂无可用配饰"
      },
      food: {
        subtitle: "你还没有购买任何物品。",
        title: "暂无可用食物"
      },
      pets: {
        subtitle: "前往商店购买宠物。",
        title: "暂无可用宠物"
      }
    },
    pet_reactions: {
      accessory: [
        "这太适合我了！",
        "我穿这个太好看了！",
        "我觉得我找到了新的风格！",
        "这太适合我了！",
        "我戴这个配饰太帅了！",
        "简直不敢相信我戴上这么好看！",
        "这个风格完全属于我！",
        "这完全是我的风格！",
        "快看我，太酷了！",
        "戴上这个我感觉超有型！",
        "哇哦，我看起来太棒了！",
        "这是为我量身定做的！",
        "我现在感觉特别时尚！",
        "这才叫时尚！",
        "我看起来真精神！",
        "可爱到爆！",
        "我觉得这是我的新宠！",
        "我感觉自己像个超级明星！",
        "我天生就适合穿这个！",
        "打扮真有趣！"
      ],
      after_eating: [
        "嗯，这个{food_name}真好吃！😋",
        "我爱吃{food_name}！❤️",
        "谢谢你的{food_name}！😊",
        "{food_name}！太好吃了！😋"
      ],
      full: [
        "我吃饱啦！😋",
        "我现在饱了！😌",
        "我吃够了，谢谢！🙏"
      ],
      hungry: [
        "我好饿啊！😢",
        "可以给我点吃的吗？🍽️",
        "我的肚子在咕咕叫了！🥺",
        "请喂我吃东西吧！🙏"
      ]
    },
    subtitle: "这些是我的物品！",
    tabs: {
      accessories: "配饰",
      food: "食物",
      pets: "宠物"
    },
    take_off_button: "脱下",
    title: "我的物品"
  },
  notifications: {
    empty: "无通知",
    messages: {
      ASSIGNMENT_CREATED: "{name} 已创建作业 {description}",
      ASSIGNMENT_GRADED: "{name} 已评分作业 {description}",
      ASSIGNMENT_SUBMITTED: "{name} 已提交作业 {description}",
      ENROLLMENT_STUDENT: "{name} 已报名参加 {description}",
      ENROLLMENT_STUDENT_AGENCY: "{name} 已注册 {description}",
      ENROLLMENT_TEACHER_AGENCY: "{name} 已加入您的机构",
      LESSON_CANCELLED: "{name} 已取消课程 {description}",
      LESSON_CANCEL_REQUESTED: "{name} 已请求取消课程 {description}",
      LESSON_RESCHEDULED: "{name} 已重新安排课程 {description}",
      LESSON_RESCHEDULE_REQUESTED: "{name} 已请求重新安排课程 {description}",
      LESSON_REVIEWED: "{name} 已为您的 {description} 评分",
      STUDENT_REVIEWED: "{name} 已为课程 {description} 提供反馈"
    },
    title: "通知"
  },
  onboarding_zoom: {
    student: {
      welcome_title: '欢迎来到 Funclass ',
      welcome_subtitle: "只需 2 个简单步骤即可完成注册！",
      title_step_1: "连接 Zoom 开始学习",
      description_step_1_1: "Funclass 使用 Zoom 上课。直接从 Funclass 加入，无需再使用链接！",
      description_step_1_2: "在 Zoom 课程中学习的同时赚取积分奖励，并让你的虚拟角色不断成长！",
      connect_button: "连接 Zoom",
      skip_button: "暂时跳过",
      watch_tutorial: "观看教程视频",
      tutorial_subtitle: "只需 1分钟即可学会使用 Funclass",
      finish_onboarding_button: "开始学习",
      handbook_button: "阅读手册"
    },
    teacher: {
    },
  },
  onboarding: {
    course: {
      browser_notice: [
        {
          acknowledgement_text: "我已阅读并理解。",
          body: [
            "请您不要使用微信自带的浏览器",
            "推荐使用以下浏览器：",
            "🔹 桌面/笔记本电脑：Chrome、Firefox 或 Edge（最新版本）",
            "🔹 移动端 iOS (12.2+): Safari Mobile",
            "🔹 移动端 Android (10.0+): Chrome Mobile",
            "请不要使用VPN"
          ],
          header: [
            "⚠️ 请阅读：支持的浏览器"
          ]
        }
      ],
      egg_unhatched: "您的宠物尚未孵化。通过课堂获取 XP，升级到 __等级 {level}__ 以孵化您的蛋！",
      teacher: [
        {
          body: [
            "在 Funclass，老师可以像玩游戏一样，用 XP（经验值）奖励学生的学习努力和进步！"
          ],
          button_text: "下一步",
          header: [],
          title: "欢迎来到 Funclass 🎉！"
        },
        {
          body: [
            "展示他们的学习过程",
            "升级他们的魔法宠物",
            "解锁更多惊喜！"
          ],
          button_text: "下一步",
          header: [
            "除非学生真正付出努力和取得进步，否则不要滥用 XP。",
            "通过 XP，学生可以..."
          ]
        },
        {
          body: [
            "积极参与课堂",
            "课堂测验",
            "完成作业",
            "充分准备课程",
            "以及其他积极的学习行为..."
          ],
          button_text: "下一步",
          header: [],
          title: "你可以奖励学生当他们..."
        },
        "",
        {
          body: [
            "阅读 Funclass 手册，了解技巧和最佳操作。"
          ],
          header: []
        }
      ]
    },
    navigation: {
      finish: "完成",
      next: "下一步",
      skip_now: "稍后跳过"
    }
  },
  profile: {
    avatar_actions: {
      my_items: "我的物品",
      pet_guide: "宠物指南",
      shop: "商店"
    },
    avatar_messages: {
      first_xp: "哇！你在上一节课获得了 {lastXP} XP。距离孵化我还差 {xpToNextLevel} XP。我想知道我会长什么样子 🐣",
      hungry: "我饿了 🥺。通过课堂赚点食物喂我吧。",
      level_up: "哇！你在上一节课获得了 {lastXP} XP。距离下一个等级还差 {xpToNextLevel} XP。继续加油！",
      pet_gone_generic: "不幸的是，你的宠物不见了... 💔",
      pet_gone_named: "不幸的是，{petName} 不见了... 💔",
      pet_revive_hint_generic: "收集至少 100 HP 来复活你的宠物。",
      pet_revive_hint_named: "收集至少 100 HP 来复活 {petName}。",
      pet_revived: "感谢你努力找回我！我想你了！现在你可以喂我了 🙂",
      welcome_back: "嗨 {name}，欢迎回来！👋 我准备好和你一起学习新东西了！📚✨",
      welcome_new: "嗨 {name} 👋，很高兴认识你！我是你的学习伙伴 {petName}。在课堂上赚点 XP 来孵化我！🐣"
    },
    coin_modal: {
      earned_coins: "哇！你赚了 {rewardAmount} Fun金币！",
      shop_button: "前往商店"
    },
    feedback_modal: {
      description: "请在下方评定您的课程体验",
      label: "为什么给出这个评分？",
      lesson_not_ended: "课程尚未结束？",
      no_rating: "无评分",
      rating_format: "{rating}/5 星",
      rules: {
        max: "反馈必须少于 300 个字符",
        min: "反馈必须多于 10 个字符",
        required: "反馈是必填项"
      },
      submit_button: "提交反馈",
      title: "课程反馈"
    },
    level_up_modal: {
      submit_button: "提交"
    },
    pet_letter: {
      letter_title_generic: "你的宠物的信",
      letter_title_named: "{petName} 的信",
      open_button: "打开",
      paragraph_1: "很高兴认识你，成为你的学习伙伴。和你一起学习很愉快。不过，最近我有点被忽视了。💔",
      paragraph_2: "所以，我决定离开一段时间，去寻找一个更有爱的环境。收集200枚金币，在商店购买药水来找回我。",
      paragraph_3: "期待不久后再见！",
      received_title_generic: "你收到了一封来自宠物的信",
      received_title_named: "你收到了来自 {petName} 的信",
      signature: "你诚挚的， \n{petName}"
    },
    revive_pet_modal: {
      revive_button: "复活",
      revive_message_generic: "你已收集到 100 HP 🎉 \n现在可以复活你的宠物了。",
      revive_message_named: "你已收集到 100 HP 🎉 \n现在可以复活你的宠物了。",
      title: "奖励"
    },
    title: "我的主页",
    your_classes: "你的课程"
  },
  quiz: {
    create: "创建测验",
    create_description: "测验描述",
    create_name: "测验名称",
    delete: "删除",
    delete_confirmation: "删除确认",
    delete_message: "您确定要删除此测验吗？",
    edit: {
      add_alt_answer: "添加其他答案",
      add_answer: "添加答案",
      add_question: "添加问题",
      delete_message: "您确定要删除此问题吗？",
      delete_question: "删除问题",
      save_question: "保存问题",
      title: "编辑测验"
    },
    edit_questions: "编辑问题",
    folder: {
      create: "创建文件夹",
      create_name: "文件夹名称",
      delete: "删除文件夹",
      delete_confirmation: "删除确认",
      delete_message: "您确定要删除此文件夹吗？这将删除文件夹中的所有测验。",
      edit: "编辑文件夹",
      name_limit: "字符不能超过 50 个",
      name_not_empty: "文件夹名称不能为空",
      save: "保存文件夹",
      title: "测验控制面板"
    },
    name_limit: "字符不能超过 50 个",
    name_not_empty: "测验名称不能为空",
    save: "保存测验",
    title: "测验控制面板"
  },
  recording: {
    delete_confirmation: "您确定要删除此录音吗？"
  },
  scheduling: {
    edit: {
      error: "更新事件时发生错误",
      options: {
        current: "此课程",
        future: "此课程及未来课程",
        title_delete: "选择要删除的事件",
        title_edit: "选择要应用更改的事件"
      },
      title: "编辑计划课程"
    },
    end_date: "结束日期",
    lesson_time: "课程时间",
    lesson_time_info: "选择您的本地时间。我们会自动调整为学生的时区。",
    recurrence: {
      biweekly: "每 2 周",
      custom: "自定义",
      daily: "每日",
      label: "重复",
      none: "无",
      occurs_on: "发生于",
      repeat_every: "每隔 {n} 小时 | 每隔 {n} 小时",
      time_unit_day: "天 | 天数",
      time_unit_week: "周 | 周数",
      weekly: "每周"
    },
    reminder: {
      hours_before: "{n} 小时前 | {n} 小时前",
      label: "提醒学生"
    },
    start_date: "开始日期"
  },
  shop: {
    buy_now_button: "立即购买",
    buy_pet_button: "购买宠物",
    cancel_button: "取消",
    confirm_button: "确认",
    level_constraint: "达到{level}级解锁此物品",
    no_content: {
      accessories: {
        subtitle: "稍后回来查看更多物品。",
        title: "暂无可用配饰"
      },
      food: {
        subtitle: "稍后回来查看更多物品。",
        title: "暂无可用食物"
      },
      pets: {
        subtitle: "稍后回来查看更多宠物。",
        title: "暂无可用宠物"
      },
      wallpapers: {
        subtitle: "稍后回来查看更多壁纸。",
        title: "暂无可用壁纸"
      }
    },
    notify: {
      pet_name_required: "请输入宠物名称"
    },
    pet_name: "宠物名称",
    pet_name_prompt: "给你的宠物起个名字吧！",
    subtitle: "你可以在这里为你的宠物购买物品！",
    title: "商店"
  },
  sidebar: {
    actions: {
      account_settings: "账户设置",
      logout: "登出"
    },
    activities: {
      homework: "作业",
      quiz: "测验",
      short_title: "活动",
      title: "活动"
    },
    agency_name_placeholder: "您的机构",
    courses: {
      calendar: "日历",
      courses: "课程",
      history: "历史",
      short_title: "课程",
      title: "课程"
    },
    general: {
      home: "主页",
      short_title: "通用",
      students: "学生",
      teachers: "教师",
      title: "通用"
    }
  },
  understandingCheck: {
    start: "您即将启动理解检查",
    student: "你现在感觉怎么样？",
    studentButtonNo1: "嗯...🤔️",
    studentButtonNo2: "有点困惑",
    studentButtonYes1: "很好！ 😄",
    studentButtonYes2: "我理解了",
    teacher: "学生现在的感受"
  },
  upload: {
    agency_logo_upload: "上传您机构的 logo",
    drag_and_drop: "或拖放",
    photo_upload: "上传您的图片",
    pick_file: "选择文件",
    square_image: "推荐使用方形图片。",
    upload: "上传",
    upload_file: "上传文件",
    upload_file_type: "仅接受 {formats} 格式。"
  },
  viewClass: {
    absence: "缺席",
    addMore: "添加更多学生",
    addStudent: "邀请学生",
    addStudents: "添加学生",
    attendance: "考勤",
    date: "日期",
    download_recording: "下载录音",
    email: "邮箱地址",
    enterEmail: "请输入学生邮箱",
    feedback_button: "反馈",
    invite: "邀请",
    lesson: "课程",
    notEmpty: "该字段不能为空",
    notValid: "邮箱格式不正确",
    recording_button: "录音",
    student_name: "学生姓名",
    tabs: {
      course_material: "课堂幻灯片",
      lesson_history: "课程记录",
      student_list: "学生列表"
    },
    xps_earned: "获得的经验值"
  }
};
